import type { SegmentTrackCartViewedEvent } from "@beautypie/segment/Track/CartViewed";
import type { SegmentTrackCheckoutStepCompletedEvent } from "@beautypie/segment/Track/CheckoutStepCompleted";
import type { SegmentTrackCheckoutStepViewedEvent } from "@beautypie/segment/Track/CheckoutStepViewed";
import type { LocaleOfStoreType } from "@beautypie/core";
import type { ItemType } from "@shared/graphql.types";
import { getPDPUrl } from "utils/getPDPUrl";
import { siteUrl } from "utils/getSiteUrl";

type Product = (
  | SegmentTrackCartViewedEvent
  | SegmentTrackCheckoutStepCompletedEvent
  | SegmentTrackCheckoutStepViewedEvent
)["properties"]["products"][0];

const notEmpty = <T>(value?: T | null): boolean =>
  value !== null && value !== undefined;

export const getProductsFromInLimitItems = (
  items: ItemType[],
  hasMembership: boolean,
  locale: LocaleOfStoreType
): Product[] => {
  return items
    .map((item, index) => {
      const { quantity, variant, membership } = item;

      let product: Partial<Product> = {
        quantity,
        position: index + 1
      };
      if (variant) {
        product = {
          quantity,
          position: index + 1,
          sku: variant.sku,
          name: variant.title,
          brand: variant.brandName,
          variant: variant.subTitle ?? "",
          price: hasMembership
            ? variant.pricing.members
            : variant.pricing.typical,
          members_price: variant.pricing.members,
          typical_price: variant.pricing.typical,
          url: `${siteUrl}${getPDPUrl(variant, locale)}`
        };
        product.price = item.origin === "discount" ? 0 : product.price;
        return product;
      }
      if (membership) {
        const { name, price, value: sku } = membership;
        product = {
          quantity,
          position: index + 1,
          sku,
          name,
          brand: "Member",
          variant: "",
          price,
          typical_price: price,
          members_price: price,
          url: ""
        };
      }
      return product;
    })
    .filter(notEmpty) as Product[];
};
